function initCartQuantity() {
    // Use event delegation to handle clicks on quantity buttons
    document.body.addEventListener('click', function(e) {
        // Find the closest matching ancestor
        const target = e.target.closest('.quantity-minus, .quantity-plus');
        if (!target) return;

        const quantityInputContainer = target.closest('.quantity-input');
        if (!quantityInputContainer) return;

        const input = quantityInputContainer.querySelector('input.qty');
        if (!input) return;

        const step = parseInt(input.step, 10) || 1;
        let currentValue = parseInt(input.value, 10);

        if (target.classList.contains('quantity-minus')) {
            const min = parseInt(input.min, 10) || 0;
            if (currentValue > min) {
                input.value = currentValue - step;
            }
        }

        if (target.classList.contains('quantity-plus')) {
            const max = parseInt(input.max, 10) || 999;
            if (currentValue < max) {
                input.value = currentValue + step;
            }
        }

        // Trigger a change event on the input to let WooCommerce know
        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);

        // Enable the update cart button
        const updateCartBtn = document.querySelector('button[name="update_cart"]');
        if (updateCartBtn) {
            updateCartBtn.disabled = false;
        }
    });
}

export { initCartQuantity };
